import { cn } from "@utils/cn.ts";
import { useRosterFocusStore } from "@/store/rosterFocusStore";

function ModalWeeklyOffThCalendarDay({
  day,
  holiday,
  isEveryFifth,
  weekDay,
}: {
  day: number;
  isEveryFifth?: boolean;
  holiday: string;
  weekDay?: string;
}) {
  const columnKey = `weeklyOff-day${day}`;
  const isHovered = useRosterFocusStore((s) => s.hoveredColumn === columnKey);
  const isSelected = useRosterFocusStore((s) => s.selectedColumn === columnKey);
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);

  const highlightBg = isSelected
    ? "rgba(169, 223, 254, 0.4)"
    : isHovered
      ? "rgba(169, 223, 254, 0.3)"
      : undefined;

  return (
    <div
      className={cn(
        "padding_hover_bg_vertical",
        isEveryFifth && "border-r border-zinc-300"
      )}
      data-column={columnKey}
      style={highlightBg != null ? { backgroundColor: highlightBg } : undefined}
    >
      <div className="padding_hover_bg_horizon !px-0">
        <div
          className={`rounded-[5px] rt_calendarDay effect_hover_bg_vertical ${holiday} flex flex-col justify-center items-center !leading-none h-[40px] !w-[34px]`}
          onMouseEnter={() => {
            setHoveredFocus({ column: columnKey, nurseId: "" });
          }}
          onMouseLeave={() => {
            clearHoveredFocus();
          }}
        >
          {weekDay && (
            <span className="text-[12px] leading-none mb-[2px]">{weekDay}</span>
          )}
          {day}
        </div>
      </div>
    </div>
  );
}

export default ModalWeeklyOffThCalendarDay;
